import React from 'react';
import ReactMarkdown from "react-markdown";
import { MessageBox, Button } from 'react-chat-elements';

import './ChatButton.css';

const ChatButton = ({ text, onClick }) => {
    return (
        <MessageBox
            className="chat-button"
            text={<ReactMarkdown>{text}</ReactMarkdown>}
            position="left"
            date={null}
            notch={false}
            onClick={onClick}
        />
    )
}

export default ChatButton;